import script from "./foot.vue?vue&type=script&setup=true&lang=js"
export * from "./foot.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__